import React from "react";
import ExpandableSection from "../../../../components/ExpandableSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import {
  faUser,
  faChair,
  faBox
} from "@fortawesome/free-solid-svg-icons";

export default function ProjectMoves() {
	
 const history = useHistory();

  // ---- DEMO DATA ----
  const moves = [
    {
      id: 1,
      code: "MOVE-001",
      origin: "Floor 3 – Finance",
      destination: "Floor 5 – Operations",
      sponsor: "J. Smith",
      people: 42,
      desks: 38,
      boxes: 126,
      status: "Planned"
    },
    {
      id: 2,
      code: "MOVE-002",
      origin: "Floor 2 – HR",
      destination: "Floor 4 – People Ops",
      sponsor: "L. Brown",
      people: 18,
      desks: 18,
      boxes: 64,
      status: "Labels Printed"
    },
    {
      id: 3,
      code: "MOVE-003",
      origin: "Floor 1 – IT",
      destination: "Floor 6 – Engineering",
      sponsor: "M. Patel",
      people: 26,
      desks: 26,
      boxes: 92,
      status: "In Progress"
    }
  ];

  // ---- STATUS STYLES ----
  function getStatusStyle(status) {
    switch (status) {
      case "Planned":
        return { background: "#e3f2fd", color: "black" };
      case "Labels Printed":
        return { background: "#ede7f6", color: "black" };
      case "In Progress":
        return { background: "#fff8e1", color: "black" };
      case "Complete":
        return { background: "#e8f5e9", color: "black" };
      default:
        return { background: "#eeeeee", color: "black" };
    }
  }

  function onMoveClick(move) {
    // stub for later navigation / modal
    console.log("Open move:", move.code);
  };
  
  function onMoveClick(move){
	history.push("/projects/moves/edit");
  };

  return (
    <ExpandableSection
      title="Moves"
      defaultExpanded={true}
    >

      <div style={{ overflowX: "auto" }}>

        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Code</th>
              <th style={styles.th}>Origin → Destination</th>
              <th style={styles.th}>Sponsor</th>
              <th style={styles.thCenter}>People</th>
              <th style={styles.thCenter}>Desks</th>
              <th style={styles.thCenter}>Boxes</th>
              <th style={styles.th}>Status</th>
            </tr>
          </thead>

          <tbody>
            {moves.map(move => (
              <tr key={move.id} style={styles.tr}>

                <td style={styles.tdLink} onClick={() => onMoveClick(move)}>
                  {move.code}
                </td>

                <td style={styles.td}>
                  {move.origin} &nbsp;→&nbsp; {move.destination}
                </td>

                <td style={styles.td}>
                  {move.sponsor}
                </td>

                <td style={styles.tdCenter}>
                  <FontAwesomeIcon icon={faUser} /> {move.people}
                </td>

                <td style={styles.tdCenter}>
                  <FontAwesomeIcon icon={faChair} /> {move.desks}
                </td>

                <td style={styles.tdCenter}>
                  <FontAwesomeIcon icon={faBox} /> {move.boxes}
                </td>

                <td style={styles.td}>
                  <span
                    style={{
                      ...styles.statusPill,
                      ...getStatusStyle(move.status)
                    }}
                  >
                    {move.status}
                  </span>
                </td>

              </tr>
            ))}
          </tbody>
        </table>

      </div>

    </ExpandableSection>
  );
}

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "13px"
  },
  th: {
    textAlign: "left",
    padding: "10px",
    borderBottom: "2px solid #ddd",
    whiteSpace: "nowrap",
	background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)"
  },
  thCenter: {
    textAlign: "center",
    padding: "10px",
    borderBottom: "2px solid #ddd",
    whiteSpace: "nowrap",
	background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)"
  },
  tr: {
    borderBottom: "1px solid #eee",
	height:"40px"
  },
  td: {
    padding: "10px",
    verticalAlign: "middle"
  },
  tdCenter: {
    padding: "10px",
    textAlign: "center",
    verticalAlign: "middle"
  },
  tdLink: {
    padding: "10px",
    color: "#1e88e5",
    cursor: "pointer",
    fontWeight: 600
  },
  statusPill: {
  	  display:'flex',
        padding: "4px 10px",
        borderRadius: "7px",
        fontSize: "12px",
  	  alignItems:'center',
  	  justifyContent:'space-around',
  	  minWidth:'70px'
   }
};
